import React from 'react';
import { Edit, Flag } from '@mui/icons-material';
import { Box, Typography, Tooltip } from '@mui/material';
import { severityColor } from '../utility/utilities';
import { variants } from '../../../variants/variants';

const ChatBubble = ({ isOwnMessage, announcement }) => {
  const { announcementText, edited } = announcement;

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: isOwnMessage ? 'flex-start' : 'flex-end',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          borderRadius: 3,
          backgroundColor: isOwnMessage ? '#0A4FAC' : '#EEF5FF',
          padding: '8px 12px',
          width: 'auto',
          maxWidth: { xs: '65vw', lg: '30vw' },
          wordWrap: 'break-word',
          marginLeft: isOwnMessage ? 'auto' : 0,
          marginRight: isOwnMessage ? 0 : 'auto',
          borderTopRightRadius: isOwnMessage ? 0 : null,
          borderTopLeftRadius: isOwnMessage ? null : 0,
          boxShadow: '0px 2px 10px rgba(0,0,0,0.1)',
        }}
      >
        <Tooltip title={`Severity flag: ${announcement.severity}`}>
          <Flag
            sx={{
              position: 'absolute',
              right: isOwnMessage ? null : 'calc(-20px)',
              left: isOwnMessage ? 'calc(-20px)' : null,
              color: severityColor(announcement.severity),
              fontSize: '13px',
              transform: 'translateY(5px)',
            }}
          />
        </Tooltip>

        {edited && (
          <Tooltip title="This announcement has been edited">
            <Edit
              sx={{
                position: 'absolute',
                right: isOwnMessage ? null : 'calc(-40px)',
                left: isOwnMessage ? 'calc(-40px)' : null,
                color: 'grey',
                fontSize: '13px',
                transform: 'translateY(5px)',
              }}
            />
          </Tooltip>
        )}

        <Typography
          variant="body1"
          color={isOwnMessage ? 'white' : 'black'}
          fontSize={variants.BODY}
          sx={{
            whiteSpace: 'pre-wrap',
            '& a': {
              color: isOwnMessage ? 'white' : 'black',
            },
          }}
          dangerouslySetInnerHTML={{ __html: announcementText }}
        />
      </Box>
    </Box>
  );
};

export default ChatBubble;
